// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"b634823a","382":"767624c9","537":"e674e839","704":"44c5ef05","793":"fcd153a7","901":"c40fcde2","940":"8ea7205a","984":"30ae1a09","995":"2bd1186c"}[chunkId] + ".chunk.js";
};